import { jwtDecode } from 'jwt-decode'
import { ref } from 'vue'
import Cookies from 'js-cookie'

const token = ref(Cookies.get('token'))

export const useToken = () => {
  const DEFAULT_EXPIRES = new Date(Date.now() + 60 * 58 * 1000)
  const subdomain = import.meta.env.DEV ? 'lexicomb.loc' : 'lexicomb.com'
  const defaultConfig = { expires: DEFAULT_EXPIRES, domain: subdomain }

  const setToken = (
    accessToken: string,
    config: { expires: number | Date; domain: string } = defaultConfig
  ) => {
    console.log('setToken called with:', { accessToken, config })
    Cookies.set('token', accessToken as string, config)
    token.value = accessToken
  }

  const setIdToken = (
    idToken: string,
    config: { expires: number | Date; domain: string } = defaultConfig
  ) => {
    console.log('setIdToken called with:', { idToken, config })
    Cookies.set('id_token', idToken as string, config)
  }
  const setRefreshToken = (
    refreshToken: string,
    config: { expires: number | Date; domain: string } = defaultConfig
  ) => {
    console.log('setRefreshToken called with:', { refreshToken, config })
    Cookies.set('refresh_token', refreshToken as string, config)
  }

  const getToken = () => {
    return token.value
  }

  const getTokenExpiration = () => {
    return Cookies.get('expires')
  }

  const getRefreshToken = () => {
    return Cookies.get('refresh_token')
  }

  const removeToken = () => {
    console.log('removeToken called, clearing tokens')
    const subdomain = import.meta.env.DEV ? 'lexicomb.loc' : 'lexicomb.com'

    Cookies.remove('token', { domain: subdomain })
    Cookies.remove('refresh_token', { domain: subdomain })
    Cookies.remove('id_token', { domain: subdomain })

    Cookies.remove('token')
    Cookies.remove('refresh_token')
    Cookies.remove('id_token')

    token.value = ''
  }

  const getUserIdFromToken = () => {
    const token = getToken()
    if (token) {
      const decodedToken = jwtDecode<{ sub: string }>(token)
      return decodedToken.sub
    }
    return null
  }

  const getUserRolesFromToken = (): string[] => {
    const token = getToken()
    if (!token) return []

    const decodedToken = jwtDecode<{
      resource_access?: { 'lexi-backend-client'?: { roles?: string[] } }
    }>(token)

    return decodedToken.resource_access?.['lexi-backend-client']?.roles || []
  }

  return {
    token,
    setToken,
    getToken,
    removeToken,
    getTokenExpiration,
    setRefreshToken,
    getRefreshToken,
    getUserIdFromToken,
    getUserRolesFromToken,
    setIdToken,
  }
}
